"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIATIVES_TABLE_LABELS = void 0;
exports.INITIATIVES_TABLE_LABELS = {
    ACTION: 'Action',
    ASSIGNED_TO: 'Assigned To',
    CREATED_ON: 'Created On',
    NO_DATA: 'No matching Initiatives found.',
    STATUS: 'Status',
    TITLE: 'Title',
    TYPE: 'Type'
};
//# sourceMappingURL=INITIATIVES_TABLE_LABELS.js.map